import { Factory } from 'miragejs';

export default Factory.extend({
  name: 'Test iPad',
  osVersion: '1.0.0',
  maximumOsVersion: '1.0.0',
  deviceType: 'iPad5',
  appVersion: '1.0.0',
  currentAppVersion: '1.0.0',
});
